<template>
    <div class="mx-2 mx-lg-5">
         <div class="card">
            <div class="card-header">
                <h3>{{ $t("headers.guestbooks") }}</h3>
            </div>
            <div class="card-body p-0">
                <table class="table table-striped table-hover table-responsive-md">
                    <thead>
                        <tr>
                            <th>{{ $t("guestbook.name") }}</th>
                            <th>{{ $t("guestbook.company") }}</th>
                            <th>{{ $t("guestbook.from") }}</th>
                            <th>{{ $t("guestbook.to") }}</th>
                            <th>{{ $t("status.status") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="guestbook in guestbooks"
                            :key="guestbook.id"
                            @click="goToGuestbookDetail(guestbook, $event)"
                            style="cursor: pointer;"
                        >
                            <td>{{ guestbook.guest_name }}</td>
                            <td>{{ guestbook.company }}</td>
                            <td>{{ guestbook.expected_from ? $d(new Date(guestbook.expected_from), 'short') : "—" }}</td>
                            <td>{{ guestbook.expected_to ? $d(new Date(guestbook.expected_to), 'short') : "—" }}</td>
                            <td>
                                <div v-if="$store.getters.hasGatehousePerm('change_guestbook')">
                                    <select class="form-select" @change="changeStatus(guestbook)" v-model="guestbook.status">
                                        <option
                                            v-for="status in statuses"
                                            :key="status.id"
                                            :value="status.id"
                                        >
                                            {{ $t("status.guestbook." + status.name) }}
                                        </option>
                                    </select>
                                </div>
                                <div v-else>
                                    {{ $t("status.guestbook." + guestbook.status_name) }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
         </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                guestbooks: [],
                statuses: [],
            }
        },
        created() {
            this.getGuestbook();
            this.getStatuses();
        },
        methods: {
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses`, {
                    params: {model: "guestbook"}
                })
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },
            getGuestbook() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/guestbooks`)
                .then(response => {
                    this.guestbooks = response.data;
                })
                .catch(error => {
                    console.error("Error loading guestbooks", error);
                });
            },
            changeStatus(guestbook) {
                const slug = this.$route.params.slug;
                const guestbookId = guestbook.id;
                const statusId = guestbook.status;
                const url = `/${slug}/guestbooks/${guestbookId}/status/edit`
                const dataPost = { status: statusId}

                this.$store.getters.api.patch(url, dataPost)
                .catch(error => {
                    console.error("Failed to update status", error);
                });
            },
            goToGuestbookDetail(guestbook, event) {
                if (event.target.closest("select")) {
                    return;
                }

                this.$router.push({
                    name: "guestbookDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id: guestbook.id,
                    }
                });
            },
        }
    }
</script>